<template>
  <div>
    <Header :right-sidebar="true" right-sidebar-title="Спортзалы">
      <template #right-sidebar>
        <sidebar-items-group title="Отображать столбцы">
          <fields-picker
            v-model="pickedFields"
            :fields="displayableGymsFields"
          />
        </sidebar-items-group>
        <sidebar-items-group
          title="Фильтры"
          :class="{ 'd-none': !hasRole(['root', 'admin']) }"
        >
          <filters-group
            :fields="gymsFields"
            :items="gyms"
            v-model="filteredItems"
          />
        </sidebar-items-group>
        <sidebar-item
          variant="success"
          to="/gyms/create"
          v-if="hasRole(['root', 'admin'])"
        >
          Добавить спортзал
          <template #icon>
            <b-icon icon="plus-square" />
          </template>
        </sidebar-item>
      </template>
    </Header>
    <Main>
      <b-table
        selectable
        select-mode="single"
        :responsive="true"
        :items="paintedRows"
        :fields="pickedFields"
        @row-clicked="item => openGym(item)"
        hover
        class="table-rounded"
        empty-text="Записей нет"
      >
        <template #cell(clients)="data">
          <router-link
            :to="
              `/gyms/${
                data.item.id
              }/month/${new Date().getFullYear()}/${new Date().getMonth() + 1}`
            "
          >
            Список клиентов
          </router-link>
        </template>
        <template #cell(prices)="data">
          <router-link :to="`/gyms/${data.item.id}/prices/`">
            Список абонементов
          </router-link>
        </template>
        <template #cell(unionsDiscounts)="data">
          <router-link :to="`/gyms/${data.item.id}/discounts/unions`">
            Скидки для профсоюзов
          </router-link>
        </template>
      </b-table>
    </Main>
  </div>
</template>
<script>
import Header from "@/components/Layout/Header";
import SidebarItemsGroup from "@/components/Layout/Sidebars/SidebarItems/SidebarItemsGroup";
import FieldsPicker from "@/components/Tables/FieldsPicker";
import FiltersGroup from "@/components/Tables/Filters/FiltersGroup";
import SidebarItem from "@/components/Layout/Sidebars/SidebarItems/SidebarItem";
import Main from "@/components/Layout/Main";
import { mapGetters } from "vuex";
import { gymsFields } from "@/views/Gyms/models/gymsTableModel";
import { displayableFields } from "@/components/Tables/defaultFields";
import { defaultRowPainter } from "@/components/Tables/rowPainters";
import pageTitleMixin from "@/mixins/pageTitleMixin";

export default {
  components: {
    Main,
    SidebarItem,
    FiltersGroup,
    FieldsPicker,
    SidebarItemsGroup,
    Header
  },
  mixins: [pageTitleMixin],
  data() {
    let displayableGymsFields = displayableFields(gymsFields);
    return {
      gymsFields,
      displayableGymsFields,
      filteredItems: [],
      pickedFields: displayableGymsFields
    };
  },
  computed: {
    ...mapGetters("user", ["hasRole"]),
    ...mapGetters("gyms", ["gyms"]),
    paintedRows: ({ filteredItems }) => defaultRowPainter(filteredItems)
  },
  methods: {
    openGym({ id }) {
      if (this.$store.getters["user/hasRole"](["admin", "root"]))
        this.$router.push(`/gyms/${id}`);
      else
        this.$router.push(
          `/gyms/${id}/month/${new Date().getFullYear()}/${new Date().getMonth() +
            1}`
        );
    }
  }
};
</script>
